// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { canWrite } from '../../../common/permissions/permissionUtil';

// Selectors
import { inboxChildrenSelector } from './documentModeSelector';
import { currentBoardUserPermissionsSelector } from '../../utils/permissions/elementPermissionsSelector';
import { isCurrentlyEditing } from '../../element/selection/currentlyEditingSelector';

// Components
import ElementCreateUtil from './elementCreate/ElementCreateUtil';

// Styles
import './MobileFloatingTool.scss';

const floatingToolSelector = createSelector(
    inboxChildrenSelector,
    currentBoardUserPermissionsSelector,
    isCurrentlyEditing,
    (inboxChildren, currentBoardPermissions, isEditing) => ({
        inboxCount: inboxChildren.size,
        showCreateButton: canWrite(currentBoardPermissions) && !isEditing,
    }),
);

const MobileFloatingTool = (props) => (
    <div className="MobileFloatingTool">
        <ElementCreateUtil {...props} />
    </div>
);

MobileFloatingTool.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    isEditable: PropTypes.bool,
};

export default connect(floatingToolSelector)(MobileFloatingTool);
